import { atom } from 'recoil';
import { Apis } from '@sparrow-marketing/contracts';

import {
  ITemplateMetrics,
  ITemplateConfiguration,
  ITemplateContent,
  ITemplateLeftNav,
  ITemplateNavigation,
  ITemplateSetup,
  ITemplateVariables,
  ITemplateVariableState,
  ITimeRange,
  SubNav,
  TemplateCommonTimeRange,
  TemplateNavigation,
  TemplateSettings,
} from './types';

export const TemplateActiveTabState = atom<{
  id: string;
  datasource: SubNav['type'];
}>({
  key: 'addon-template-active-datasource',
  default: {
    id: '',
    datasource: '',
  },
});

export const LeftNavigationState = atom<ITemplateLeftNav | null>({
  key: 'template-left-navigation',
  default: null,
});

export const TemplateNavigateState = atom<TemplateNavigation>({
  key: 'addon-template-navigate',
  default: 'setup',
});

export const SettingNavigateState = atom<string>({
  key: 'addon-setting-navigate',
  default: 'details',
});

export const VariableTabState = atom<ITemplateVariableState>({
  key: 'variable-tab',
  default: {
    active: '',
    value: '',
  },
});

export const VariablesState = atom<ITemplateVariables>({
  key: 'template-variable',
  default: {},
});

export const TemplateSettingsState = atom<TemplateSettings>({
  key: 'template-setting-state',
  default: {
    time: {},
    variable: {},
  },
});

export const IsSuccessModalState = atom<boolean>({
  key: 'is-success-modal',
  default: false,
});

export const TemplateSetupState = atom<ITemplateSetup>({
  key: 'template-setup-state',
  default: {
    templateName: '',
    templateDescription: '',
    templateVisibility: { label: 'Private', value: 'private' },
    previewImage: '',
  },
});

export const ValidateTemplateNavigation = atom<ITemplateNavigation>({
  key: 'validate-template-navigation',
  default: {
    setup: true,
    setting: false,
    review: false,
  },
});

export const TemplateContentTabState = atom<ITemplateContent>({
  key: 'template-content-tab-state',
  default: {},
});

export const TemplateMetricsTabState = atom<ITemplateMetrics>({
  key: 'template-metrics-tab-state',
  default: {},
});

export const TemplateChartsTabState = atom<ITemplateMetrics>({
  key: 'template-charts-tab-state',
  default: {},
});

export const TemplateTimeRangesTabState = atom<ITimeRange>({
  key: 'template-time-range-tab-state',
  default: {},
});

export const TemplateApiDataState = atom<any>({
  key: 'template-api-data',
  default: {},
});

export const UpdateTemplateDataState = atom<boolean>({
  key: 'update-template-data-state',
  default: false,
});

export const TemplateDocPropsState = atom<Apis.SparrowApi.IDocument<any, any>>({
  key: 'template-doc-props',
  default: {
    businessId: '',
    data: {},
    docId: '',
  },
});

export const TemplateCommonConfigurationState = atom<ITemplateConfiguration>({
  key: 'template-common-configurations',
  default: {
    hints: {},
    rules: {},
    timeRanges: {},
  },
});

export const TemplateCommonTimeRangeSourceState = atom<TemplateCommonTimeRange>(
  {
    key: 'template-common-time-range-state',
    default: {},
  }
);
